<nb-card>
  <nb-card-header>Importar informes</nb-card-header>
  <nb-card-body><p>El archivo importado contiene errores en {{registrosMessage}}</p>
  <p>Puede descargar un archivo con los registros con errores pulsando en el botón Descargar</p>
  <p *ngIf="reportsToSave.valid.length > 0">Puede proceder con la importación de los registros válidos pulsando en el botón Importar</p>
  </nb-card-body>
  <nb-card-footer>
  <div class="row">
    <div class="col-md-4">
      <button nbButton status="info" (click)="cancelar()">Cancelar</button>
    </div>
    <div class="col-md-4 text-right">
      <button nbButton status="primary" (click)="descargar()">Descargar</button>
    </div>
    <div class="col-md-4 text-right" *ngIf="reportsToSave.valid.length > 0">
      <button nbButton status="primary" (click)="importar()">Importar</button>
    </div>
  </div>


  </nb-card-footer>
</nb-card>
